<template>
  <div class="ts-app-shell_fh">
  <CheckListTemplate>
    <div class="check-list-form">
      <div class="content-type">
        <span class="numeral-item">1.</span>
        <span>Identity Information</span>
      </div>
      <p>Please enter your personal identity information</p>
      <el-form @submit.native.prevent="initiateCheckList">
        <div class="content-item">
          <el-row>
            <el-col :xl="10" :lg="10" :md="10" :sm="10">
              <label role="text">First Name:</label>
              <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.FirstName')">
                <el-input placeholder="Enter First Name" v-model="firstName" disabled/>
              </el-form-item>
            </el-col>
            <el-col :offset="4" :xl="10" :lg="10" :md="10" :sm="10">
              <label role="text">Last Name:</label>
              <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.SurName')">
                <el-input placeholder="Enter Last Name" v-model="surName" disabled/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Unique ID:</label>
              <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.UniqueId')">
                <el-input
                  placeholder="Enter Unique ID/ Social Security Number" v-model="uniqueId"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div> -->
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Email:</label>
              <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.Email')">
                <el-input
                  v-model="email"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Date:</label>
              <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.Date')">
                <el-date-picker
                  v-model="date"
                  type="date"
                  placeholder="MM/DD/YYY"
                  value-format="MM/dd/yyyy"
                  format="MM/dd/yyyy"
                  size="small"
                  :default-value="new Date()"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="form-note-section">
          <div class="icon-box"><i class="fas fa-exclamation fa-lg"></i></div>
          <div class="note-text">
            Note: Throughout this application, it is not mandatory to upload
            personal documentation as necessary documentation can be verified by
            a designated staff member in person.
          </div>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col :xs="4" :md="4" :lg="4">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Cancel
              </el-button>
            </el-col>
            <el-col :offset="2" :xs="4" :md="4" :lg="4">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="initiateCheckList"
              >
                Continue
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </CheckListTemplate>
  <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { CheckListTemplate, TSLoading },
  data(){
    return{
      modelState: {},
      loading: false,
      email: null,
      firstName: null,
      surName: null,
      uniqueId: null,
      date: null
    }
  },
  computed: {
    editChecklistId() {
      return localStorage.getItem('editChecklist');
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm(
        "Are you sure you want to leave this page?",
        "Warning!",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          type: "warning",
          center: true,
        }).then(() => {
          localStorage.removeItem('editChecklist');
          this.loading = true;
          next();
        })
        .catch(() => false);
    } else {
      next();
    }
  },
  created(){
    debugger;
    window.scrollTo(0,0);
    if(this.editChecklistId == null){
      // new checklist
      this.date = new Date();
      this.firstName = this.$store.state.account.current_user.firstname;
      this.surName = this.$store.state.account.current_user.surname;
      this.email = this.$store.state.account.current_user.email;
    }else{
      this.loading = true;
      // this.$store.dispatch("wioa/getCheckliStstatusByClient", this.$store.state.account.current_user.id).then((res) => {
      //   debugger;
      //   this.loading = true;
      //   if(res.checklistStatusId == 0 || res.checklistStatusId == 3 || res.checklistStatusId == 4 || res.checklistStatusId == 5){
      //     this.$store
      //     .dispatch("wioa/getChecklistToReview", res.checklistId)
      //     .then((res) => {
      //       debugger;
      //       localStorage.setItem("editChecklist", res.checklist.id);
      //       this.email = this.$store.state.account.current_user.email;
      //       this.firstName = res.checklist.firstName;
      //       this.surName = res.checklist.surName;
      //       this.uniqueId = res.checklist.uniqueId;
      //       this.date = new Date(res.checklist.date);
      //       this.jobSeekerId = res.checklist.jobSeekerId;
      //       this.userId = res.checklist.userId;
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      //   }
      // })
      // .catch(() => { //if no records found
      //   // this.$router.push({ name: "WioaChecklist" });
      // })
      // .finally(() => {
      //   this.loading = false;
      // });

      this.$store
          .dispatch("wioa/getChecklistToReview", this.editChecklistId)
          .then((res) => {
            debugger;
            localStorage.setItem("editChecklist", res.checklist.id);
            this.email = this.$store.state.account.current_user.email;
            this.firstName = res.checklist.firstName;
            this.surName = res.checklist.surName;
            this.uniqueId = res.checklist.uniqueId;
            this.date = new Date(res.checklist.date);
            this.jobSeekerId = res.checklist.jobSeekerId;
            this.userId = res.checklist.userId;
          })
          .finally(() => {
            this.loading = false;
          });

      // this.$store.dispatch("wioa/getChecklistToReview", this.editChecklistId).then((res) => {
      //   debugger;
      //   this.firstName = res.checklist.firstName;
      //   this.surName = res.checklist.surName; 
      //   this.uniqueId = res.checklist.uniqueId;
      //   this.date = new Date(res.checklist.date);
      //   this.jobSeekerId = res.checklist.jobSeekerId;
      //   this.userId = res.checklist.userId;
      // })
      // .finally(() => {
      //   this.loading = false;
      // });
    }
  },
  methods: {
    backToDashboard() {
      // TODO: created method for creation of wioa checklist data
      this.$router.push({ name: "WioaDashboard" });
    },
    initiateCheckList() {
      this.loading = true;
      let checklist = {
        "id": (this.editChecklistId == null) ? null : this.editChecklistId,
        "email": this.email,
        "firstName": this.firstName,
        "surName": this.surName,
        "uniqueId": this.uniqueId,
        "jobSeekerId": this.$store.state.account.applicant_user_info.jobSeekerId,
        "userId": this.$store.state.account.current_user.id,
        "date": (this.date == null) ? null : new Date(this.date)
      }

      var endpoint = (this.editChecklistId == null) ? "wioa/createCheckList" : "wioa/updateCheckList";
      this.$store.dispatch(endpoint, checklist).then((res) => {
        debugger;
        if(res){
          this.$router.push({ name: "WioaChecklistTwo", params: { checklistId: res }});
          localStorage.setItem('editChecklist', res);
        }
      }).catch((res) => {
        debugger;
        this.modelState  = res;
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
